import React, { useCallback, useContext, useState } from 'react';
import Loader from '@/components/Layout/Loader';
import ProEmailsNewList from '@/components/Email/ProEmail/ProEmailsNewList';
import ProEmailNewTitle from '@/components/Email/ProEmail/ProEmailNewTitle';
import { EmailsContext } from '@/contexts/Emails/context';
import FaqEmails from '@/components/FrequentlyQuestions/FaqEmails';
import styles from './styles.module.css';
import { SUPPORT_URL } from '@/config/urls/supportUrls';
import { TitanWithoutDomainModal } from '@/components/Email/TitanWithoutDomainModal';
import { useAiChat } from '@/hooks/AiChat';

const ProEmailListWrapper = () => {
  const {
    firstLoad, loadingCpanel, loadingProEmails,
  } = useContext(EmailsContext);
  const [displaySearch, setDisplaySearch] = useState(true);
  const { aiChatForm } = useAiChat();

  const initialTitanWithoutDomainModalValue = { display: false, hostingId: null };
  const [displayTitanWithoutDomainModal, setDisplayTitanWithoutDomainModal] = useState(initialTitanWithoutDomainModalValue);

  const handleOpenTitanWithoutDomainModal = useCallback(({ hostingId }) => {
    setDisplayTitanWithoutDomainModal({ display: true, hostingId });
  }, []);

  const setEnableSearch = (isEnabled) => {
    setDisplaySearch(isEnabled);
  };

  if (firstLoad || loadingCpanel || loadingProEmails) {
    return <Loader data-testid="loader" />;
  }

  return (
    <>
      {aiChatForm({ withoutMargin: true })}
      <ProEmailNewTitle displaySearch={displaySearch} />
      <ProEmailsNewList handleOpenTitanWithoutDomainModal={handleOpenTitanWithoutDomainModal} setEnableSearch={setEnableSearch} />
      <div className={styles.bottomInfoWrapper}>
        <FaqEmails link={SUPPORT_URL} />
      </div>
      {displayTitanWithoutDomainModal.display && (
      <TitanWithoutDomainModal
        domain={displayTitanWithoutDomainModal.domain}
        hostingId={displayTitanWithoutDomainModal.hostingId}
        onClose={() => setDisplayTitanWithoutDomainModal(initialTitanWithoutDomainModalValue)}
      />
      )}
    </>
  );
};

export default ProEmailListWrapper;
